import React from 'react'
import { Snackbar } from '@mui/material';
import MuiAlert from '@mui/material/Alert';
import './MySnackbar.css';

const MySnackbar = ({ open, setOpen }) => {
    const handleClose = (event, reason) => {
        if(reason ==='clickaway') return;

        setOpen(false);
    }

  return (
    <div className = "MySnackbar">
        <Snackbar 
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={open}
        autoHideDuration={3000}
        onClose={handleClose}
        >
            <MuiAlert onClose={handleClose} severity="success" elevation={6} variant="filled">
                Transaction created successfully.
            </MuiAlert>
        </Snackbar>
    </div>
  )
}

export default MySnackbar